import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findAllDivisions = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/divisions/getAll${query}`, {
        headers,
    });
};

export const findDivisions = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/divisions${query}`, {
        headers,
    });
};

export const findDivisionById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/divisions/${id}`, {
        headers,
    });
};

export const searchDivisions = (headers, value) => {
    let query = "";
    if (value) {
        query = `?unsignedName=${value}`;
    }
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/divisions/search${query}`, {
        headers,
    });
};
